// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LatestNews_wrapper__3JVzw","title":"LatestNews_title__3c71C"};